//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: {
        building_ranking: {
            type: Object
        }
    },
    computed: {
        url () {
            const { ranking_type, zone } =  this.building_ranking
            return `/activity_a/building_rank/main?type=${ranking_type}&zone=${zone}`
        },
        type_name () {
            const { ranking_type } =  this.building_ranking
            return {
                comments: '热评榜',
                views: '人气榜',
                follows: '关注榜'
            }[ranking_type]
        }
    }
}
